<template>
  <el-row class="container">
    <el-col :offset="4" :span="16">
      <logo :title="translate.title" :primary-color="primaryColor"></logo>
      <form v-if="state === 'reset'" @submit.prevent="submit">
        <p>{{ translate.subtitle }}</p>
        <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" style="margin: auto; width:90%;">
          <tr>
            <td style="text-align: left;font-weight: bold;padding: 1.2em 0.8em;" class="">
              {{ translate.pw_new1 }}<br>
              <input v-model="pw_new1" class="input password-input" :placeholder="translate.pw_new1_ph" type="password" style="margin: auto; width:90%;border-style: none none solid none;border-bottom-color:rgb(210, 210, 210);">
            </td>
          </tr>
          <tr>
            <td style="text-align: left;font-weight: bold;padding: 1.2em 0.8em;" class="">
              {{ translate.pw_new2 }}<br>
              <input v-model="pw_new2" class="input password-input" :placeholder="translate.pw_new2_ph" type="password" style="margin: auto; width:90%;border-style: none none solid none;border-bottom-color:rgb(210, 210, 210);">
            </td>
          </tr>
          <tr>
            <td v-if="reset_error1" class="reset_error">
              <h3 style="margin: 0;">{{ translate.length_warn }}</h3>
              {{ translate.length_desc }}
            </td>
          </tr>
          <tr>
            <td v-if="reset_error2" class="reset_error">
              <h3 style="margin: 0;">{{ translate.not_match }}</h3>
              {{ translate.not_match_desc }}
            </td>
          </tr>
          <tr>
            <td v-if="reset_error3" class="reset_error">
              <h3 style="margin: 0;">{{ translate.server_error }}</h3>
              {{ translate.server_error_desc }}
            </td>
          </tr>
        </table>
        <button type="submit" :style="{background: primaryColor, 'border-color': primaryColor}">{{ translate.reset_button }}</button>
      </form>
      <p v-if="state === 'expired'">{{ translate.link_expired }}</p>
      <p v-if="state === 'done'">{{  updateAppName(translate.reset_done) }}</p>
      <company :name="footer.companyName" :url="footer.companyUrl" :address="footer.companyAddress" :contact="footer.companyContact" :primary-color="primaryColor" :lang="lang"></company>
    </el-col>
  </el-row>
</template>

<script>
  import main from './Reset.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import '../style.scss';
  @import './Reset.scss';
</style>



// WEBPACK FOOTER //
// Reset.vue?fca6738a